module.exports = __webpack_public_path__ + "img/alert.035f5bf3.svg";